/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForDeviceVersionHistoryElementResponse,
    ReportForDeviceVersionHistoryElementResponseFromJSON,
    ReportForDeviceVersionHistoryElementResponseFromJSONTyped,
    ReportForDeviceVersionHistoryElementResponseToJSON,
} from './ReportForDeviceVersionHistoryElementResponse';

/**
 * 
 * @export
 * @interface ReportForDeviceResponseDeviceStatusVersionElement
 */
export interface ReportForDeviceResponseDeviceStatusVersionElement {
    /**
     * 
     * @type {ReportForDeviceVersionHistoryElementResponse}
     * @memberof ReportForDeviceResponseDeviceStatusVersionElement
     */
    device: ReportForDeviceVersionHistoryElementResponse;
    /**
     * 
     * @type {ReportForDeviceVersionHistoryElementResponse}
     * @memberof ReportForDeviceResponseDeviceStatusVersionElement
     */
    target: ReportForDeviceVersionHistoryElementResponse;
}

export function ReportForDeviceResponseDeviceStatusVersionElementFromJSON(json: any): ReportForDeviceResponseDeviceStatusVersionElement {
    return ReportForDeviceResponseDeviceStatusVersionElementFromJSONTyped(json, false);
}

export function ReportForDeviceResponseDeviceStatusVersionElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceResponseDeviceStatusVersionElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'device': ReportForDeviceVersionHistoryElementResponseFromJSON(json['device']),
        'target': ReportForDeviceVersionHistoryElementResponseFromJSON(json['target']),
    };
}

export function ReportForDeviceResponseDeviceStatusVersionElementToJSON(value?: ReportForDeviceResponseDeviceStatusVersionElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'device': ReportForDeviceVersionHistoryElementResponseToJSON(value.device),
        'target': ReportForDeviceVersionHistoryElementResponseToJSON(value.target),
    };
}

